import { eq } from 'tio-ui/utilities';
import Popover from 'tio-reimagined/components/popover';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import type IntlService from 'ember-intl/services/intl';
import { PhCircle } from 'ember-phosphor-icons';

interface SlrStatusTextArgs {
  Args: {
    status: string;
    lastPaymentDate?: string;
  };
}

export default class SlrStatusText extends Component<SlrStatusTextArgs> {
  @service declare intl: IntlService;

  get status() {
    switch (this.args.status.toLowerCase()) {
      case 'disbursed':
        return this.intl.t('slr.in_progress');
      case 'purgatory':
        return this.intl.t('slr.error.needs_attention');
      default:
        return this.args.status;
    }
  }

  get iconClass() {
    const iconColors: { [key: string]: string } = {
      'Payment Sent': 'text-green-500',
      Pending: 'text-yellow-400',
      'In Progress': 'text-cyan-500',
      'Needs Attention': 'text-red-500',
    };
    return 'text-sm mr-1 ' + (iconColors[this.status] || 'text-yellow-400');
  }

  <template>
    <div class="flex items-center">
      <PhCircle @size="16" @weight="fill" class="{{this.iconClass}} align-middle" />
      <Popover @triggerMode="hover">
        <:trigger as |pop|>
          <span class="underline capitalize" {{pop.register}} {{pop.hoverHandlers}}>
            {{this.status}}
          </span>
        </:trigger>
        <:body>
          <div class="p-2">
            <h3 class="font-semibold">{{t "dashboard_tiles.slr_payment_tip_header"}}</h3>
            {{#if (eq @status "Payment Sent")}}
              {{#let
                (safeFormatDate @lastPaymentDate day="numeric" month="numeric" year="numeric")
                as |date|
              }}
                <p>{{t "dashboard_tiles.slr_payment_sent_tip_body" date=date}}</p>
              {{/let}}
            {{else if (eq @status "Pending")}}
              <p>{{t "dashboard_tiles.slr_payment_pending_tip_body"}}</p>
            {{else if (eq @status "In Progress")}}
              <p>{{t "dashboard_tiles.slr_in_progress_tip_body"}}</p>
            {{/if}}
          </div>
        </:body>
      </Popover>
    </div>
  </template>
}
